module.exports = __webpack_public_path__ + "img/logo.d1331e1f.png";